import { cn } from "../../lib";

interface IActionIconProps {
  icon: JSX.Element;
  title: string;
  onClick: () => void;
  className?: string;
  busy?: boolean;
}

const ActionIcon: React.FC<IActionIconProps> = ({ icon, title, onClick, className, busy }) => (
  <div
    className={cn("size-5 cursor-pointer", className, { "opacity-50 pointer-events-none": busy })}
    title={title}
    onClick={onClick}
  >
    {icon}
  </div>
);

export default ActionIcon;
